export const locale = {
    lang: 'en',
    data: {        
        'BUTTONS': {
            'GO': 'OK',
            'CANCEL': 'Undo'
        }
    }
};

